type Props = React.SVGAttributes<SVGSVGElement> & { fillPercent: number };

export default function IndicatorClassicScale({ fillPercent, ...restProps }: Props) {
  const percent = ((130 - 10) / 100) * (fillPercent < 100 ? fillPercent : 100);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="128"
      viewBox="0 0 40 128"
      fill="none"
      {...restProps}
    >
      <g clipPath="url(#clip0_89_320)">
        <path
          opacity="0.1"
          d="M24.8059 121.932C14.0707 105.246 7.58716 85.2296 7.08665 63.6523C6.59713 42.5488 11.8671 22.6905 21.41 5.74961"
          stroke="white"
          strokeWidth="10.8138"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M24.8059 121.932C14.0707 105.246 7.58716 85.2296 7.08665 63.6523C6.59713 42.5488 11.8671 22.6905 21.41 5.74961"
          stroke="#FFC147"
          strokeWidth="10.8138"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeDashoffset="0"
          strokeDasharray={`${percent} ${130}`}
        />
        <path
          d="M32.0099 117.974L38.6181 113.124"
          stroke="white"
          strokeWidth="0.865103"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3141 64.1325L22.3871 63.7722"
          stroke="white"
          strokeWidth="0.865103"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.254 8.89054L34.2379 13.1243"
          stroke="white"
          strokeWidth="0.865103"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.8395 108.4L31.8443 105.525"
          stroke="#FFB45C"
          strokeWidth="0.432551"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M22.1055 98.0365L27.4128 95.7586"
          stroke="#FFB45C"
          strokeWidth="0.432551"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M18.513 87.1754L24.0423 85.5819"
          stroke="#FFB45C"
          strokeWidth="0.432551"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M16.1528 75.9831L21.8207 75.0328"
          stroke="#FFB45C"
          strokeWidth="0.432551"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M15.1665 53.083L20.9076 53.5101"
          stroke="#FFB45C"
          strokeWidth="0.432551"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M16.5536 41.7179L22.186 42.7939"
          stroke="#FFB45C"
          strokeWidth="0.432551"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M19.1792 30.5398L24.6216 32.3098"
          stroke="#FFB45C"
          strokeWidth="0.432551"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M22.974 19.8066L28.2253 22.2275"
          stroke="#FFB45C"
          strokeWidth="0.432551"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_89_320">
          <rect
            width="36"
            height="127"
            fill="white"
            transform="translate(0.418945 0.850868) rotate(-1.32881)"
          />
        </clipPath>
      </defs>
    </svg>
  );
  // const percent = (SECTOR_LENGTH / 100) * (fillPercent < 100 ? fillPercent : 100);

  // return (
  //   <svg
  //     width="40"
  //     height="126"
  //     viewBox="0 0 40 126"
  //     xmlns="http://www.w3.org/2000/svg"
  //     {...restProps}
  //   >
  //     <g fill="none">
  //       <circle
  //         {...CENTER}
  //         r={RADIUS}
  //         strokeWidth={STROKE_WIDTH}
  //         stroke="#130F14"
  //         strokeOpacity="0.5"
  //         strokeDasharray={`${SECTOR_LENGTH} ${CIRCLE_LENGTH - SECTOR_LENGTH}`}
  //         strokeDashoffset={STROKE_DASHOFFSET}
  //         className="transition-all"
  //       />
  //       <circle
  //         {...CENTER}
  //         r={RADIUS}
  //         strokeWidth={STROKE_WIDTH}
  //         stroke="#FFC147"
  //         strokeDasharray={`${percent} ${CIRCLE_LENGTH - SECTOR_LENGTH}`}
  //         strokeDashoffset={STROKE_DASHOFFSET}
  //         className="transition-all"
  //       />
  //       {WHITE_STROKE_COORDINATES.map((item) => (
  //         <line key={item.y1} {...item} stroke="white" strokeLinecap="round" />
  //       ))}
  //       {ORANGE_STROKE_COORDINATES.map((item) => (
  //         <line key={item.y1} {...item} stroke="#FFB45C" />
  //       ))}
  //     </g>
  //   </svg>
  // );
}
